var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82125 3.72239C1.19097 3.01796 0.875826 2.66574 0.863939 2.3664C0.853612 2.10636 0.965359 1.85643 1.16603 1.69074C1.39704 1.5 1.86966 1.5 2.81491 1.5H15.184C16.1293 1.5 16.6019 1.5 16.8329 1.69074C17.0336 1.85643 17.1453 2.10636 17.135 2.3664C17.1231 2.66574 16.808 3.01796 16.1777 3.72239L11.4225 9.03703C11.2968 9.17745 11.234 9.24766 11.1892 9.32756C11.1495 9.39843 11.1203 9.47473 11.1027 9.55403C11.0828 9.64345 11.0828 9.73766 11.0828 9.92609V14.382C11.0828 14.5449 11.0828 14.6264 11.0565 14.6969C11.0333 14.7591 10.9955 14.8149 10.9463 14.8596C10.8907 14.9102 10.815 14.9404 10.6637 15.001L7.83039 16.1343C7.5241 16.2568 7.37096 16.3181 7.24802 16.2925C7.14052 16.2702 7.04617 16.2063 6.98551 16.1148C6.91613 16.0101 6.91613 15.8452 6.91613 15.5153V9.92609C6.91613 9.73766 6.91613 9.64345 6.89623 9.55403C6.87858 9.47473 6.84943 9.39843 6.8097 9.32756C6.76491 9.24766 6.70209 9.17745 6.57645 9.03703L1.82125 3.72239Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9981cccbc41a495bd92efa9c76e078d6.svg";
export { ForwardRef as ReactComponent };